module.exports = __webpack_public_path__ + "static/parade-2020-house52-4251d8d121bc7837c61e7022e7e6a1e2.jpg";